import { Component, inject, input, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { UrlService } from '../../../services/url/url.service';
import { getWidgetsLabels } from './common-nps-selector.widget.labels';

@Component({
	selector: 'common-nps-selector',
	standalone: true,
	templateUrl: './common-nps-selector.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./common-nps-selector.widget.scss'],
})
export class CommonNetPromoterScoreWidget implements OnInit {


	public key = input.required<string>();
	public value = input.required<number | undefined>();
	public updateValue = output<{ key: string, value: number }>();
	private urlService = inject(UrlService);
	public labels = getWidgetsLabels(this.urlService);
	public netPromoter = signal<number | undefined>(undefined);
	saving = false;


	ngOnInit() {
		this.netPromoter.set(this.value());
	}


	public scoreChanged(value: number) {

		if (value !== undefined) {
			this.saving = true;
			this.netPromoter.set(value);
			this.saving = false;

			this.updateValue.emit({ value, key: this.key() });
		}
	}
}
